export const TOAST_MESSAGES = {
    VENDOR_FETCH_FAILED: "Failed to fetch Vendors.",
    UPDATE_VENDOR_FAILED: "Failed to update Vendor",
    UPDATE_VENDOR_SUCCESS: "Vendor updated successfully",
    VENDOR_CREATE_FAILED: "Failed to create Vendor",
    VENDOR_SUCCESS: "Vendor created successfully",
    VENDOR_PRODUCT_SUCCESS:"Vendor product added successfully",
    FAILED_FETCH_PRODUCT:"Failed to fetch vendor products",
    VENDOR_PRODUCT_CREATE_FAILED: "Failed to add vendor product.",
    VENDOR_PRODUCT_DELETE_SUCCESS: "Vendor product deleted successfully!",
    VENDOR_PRODUCT_DELETE_FAILED: "Failed to delete vendor product.",
    DELETE_VENDOR_SUCCESS: "Vendor deleted successfully",
    DELETE_VENDOR_FAILED: "Failed to delete Vendor!",
    DELETE_VENDOR_ERROR: "Error deleting Vendor!",
    VENDOR_DELETE_ALERT: "Are you sure you want to delete this Vendor?"
}

export const VENDOR_COLUMNS = [
    "name",
    "contact_person_name",
    "mobile",
    "address",
    "gst_details",
    "actions",
]
export const VENDOR_LABELS = {
    name: "Vendor Name",
    contact_person_name: "Contact Person Name",
    mobile: "Mobile",
    address: "Address",
    gst_details: "GSTIN",
    actions: "Actions",
};

export const VENDOR_MODES = {
    EDIT: "edit",
    VIEW: "view",
    CREATE:"create",
};

export const VENDOR_MATERIAL_COLUMNS = [
    "product_name",
    "category_name",
    "UOM",
    "specification",
    "action",
]

export const VENDOR_MATERIAL_LABELS = {
    product_name: "Product Name",
    category_name:"Category",
    UOM: "UOM",
    specification: "Specification",
    action:"Action",
}